import { IGridRow, IGridColumn, IGridCell } from '../interfaces';

/** track columns (this = the item being iterated over) */
export function columnTracker(index: number, column: IGridColumn): string {
	if (column?.trackByID) {
		return column.trackByID(this, column);
	}
	
	return `column_${index}`;
}

/** track rows (this = the item being iterated over) */
export function rowTracker(index: number, row: IGridRow): string {
	if (row?.trackByID) {
		return row.trackByID(this, row);
	}
	
	return `row_${index}`;
}

/** track cells (this = the item being iterated over) */
export function cellTracker(index: number, cell: IGridCell): string {
	if (cell?.trackByID) {
		return cell.trackByID(this, cell);
	}
	return `cell_${index}`;
}
